import React from "react";
import { useTranslation } from "gatsby-plugin-react-i18next";
import Title from "@atoms/Title/Title";
import Section from "@atoms/Section/Section";
import { useFetchChapterSlug, useTracking } from "../../hooks";
import Link from "@components/Link";
import Icon from "@atoms/Icon/Icon";
import { IconShare } from "@atoms/Icon/list";
import { useLocale } from "@hooks";
import { AnalyticsEventType } from "../../context/TrackingProvider";

const HeaderNavSubMenuChapter = () => {
	const { t } = useTranslation();
	const { currentLanguage } = useLocale();
	const { mainLinks } = useFetchChapterSlug();
	const { track } = useTracking();

	if (!mainLinks) return <></>;

	return (
		<Section spacingBottom="xs">
			{mainLinks.map((item: any) => (
				<Link className="HeaderNav--item--link" to={`/${item?.slug}`}>
					<Title size="l" theme="white">
						{item?.subNavLabel}
					</Title>
				</Link>
			))}
			<Link to="/for-therapists/" className="HeaderNav--item--link">
				<Title size="l" theme="white">
					{t("nav.label.join.as.psychologist")}
				</Title>
			</Link>
			<a
				href={`${process.env.GATSBY_AEPSY_B2B_URL}/${currentLanguage}`}
				target="_blank"
				rel="noreferrer"
				className="HeaderNav--item--link HeaderNav--external-link-with-icon"
				onClick={() => {
					track({
						eventType: AnalyticsEventType.GButtonClick,
						data: {
							buttonName: "header_navigation_sub_menu_chapter",
							sourceUrl: window.location.pathname,
							targetUrl: `${process.env.GATSBY_AEPSY_B2B_URL}/${currentLanguage}`,
						},
					});
				}}
			>
				<Title size="l" theme="white">
					{t("nav.label.for.partners")}
				</Title>
				<Icon icon={<IconShare />} variant="outlined" theme="white" size="xs" />
			</a>
		</Section>
	);
};

export default HeaderNavSubMenuChapter;
